export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Notifications.vue?vue&type=template&id=abcbebdc&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/NotificationPlugin/Notifications.vue?vue&type=template&id=abcbebdc&scoped=true
// module id = 2788
// module chunks = 31